import * as Yup from 'yup'

export const newRfidValidation = Yup.object({
  rfIdTag: Yup.string().required('Please enter your rfidTag'),
  userId: Yup.string().required('Please enter your user Id'),
  expiryDate: Yup.date().required('Please choose your expiry date'),
  comments: Yup.string().required('Please leave your comments'),
  minAmount: Yup.number().required('Please Provide Minimum Amount For Each Charging'),
})
